module.exports = __webpack_public_path__ + "img/arrow_last.127ddbb9.svg";